import { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export default function AdminAnalytics() {
  const [stats, setStats] = useState({ daily: [], weekly: [], monthly: [] });
  const [selected, setSelected] = useState("daily"); // default view

  useEffect(() => {
    fetch("https://backend.ysskytravel.com/api/analytics/stats")
      .then((r) => r.json())
      .then((d) => setStats(d))
      .catch((err) => console.error("Analytics error:", err));
  }, []);

  const currentData = stats[selected];

  const chartData = {
    labels: currentData.map((r) => r.country),
    datasets: [
      {
        label: "Visitors",
        data: currentData.map((r) => r.visits),
        backgroundColor: "#4a8a2c",
      },
    ],
  };

  return (
    <div className="p-6 bg-white rounded-xl shadow space-y-6">

      {/* Switch Buttons */}
      <div className="flex gap-3">
        {["daily", "weekly", "monthly"].map((type) => (
          <button
            key={type}
            onClick={() => setSelected(type)}
            className={`px-4 py-2 rounded-lg font-semibold border transition 
              ${selected === type
                ? "bg-primary text-white border-blue-600"
                : "bg-blue-600 text-white border-gray-300 hover:bg-gray-200"
              }`}
          >
            {type.toUpperCase()}
          </button>
        ))}
      </div>

      {/* Chart */}
      <div>
        <Bar data={chartData} />
      </div>

    </div>
  );
}
